/**
 * Spacing unit helpers that resolve to pre-computed CSS custom properties.
 *
 * - `su` — default 8px grid
 * - `suaf` — 10px advanced flow grid
 * - Values matching a known step return `var(--su-*)`, others fall back to `calc()`.
 */

const STEPS = new Set([0.25, 0.5, 0.75, 1, 1.5, 2, 2.5, 3, 4, 5, 6, 7, 8, 9]);

export function su(...values: number[]) {
  return values.map((v) => toVar('su', v)).join(' ');
}

export function suaf(...values: number[]) {
  return values.map((v) => toVar('suaf', v)).join(' ');
}

function toVar(prefix: string, value: number) {
  if (!STEPS.has(value)) {
    return `calc(var(--${prefix}) * ${value})`;
  }

  if (Number.isInteger(value)) {
    return `var(--${prefix}-${value})`;
  }

  return `var(--${prefix}-${value.toFixed(2).replace('.', '-')})`;
}

const SU_BASE = 8;

export function suPx(value: number) {
  return value * SU_BASE;
}
